import {Typography, Grid} from "@mui/material"
import React from "react"

interface FieldDisplayProps {
	label?: string
	data: string
	direction?: "row" | "row-reverse" | "column" | "column-reverse"
}
const FieldDisplay = (props: FieldDisplayProps) => {
	return (
		<Grid container direction={props.direction ? props.direction : "row"}>
			{props.label && (
				<Grid item>
					<Typography variant="subtitle2" color="textSecondary" align="left" component="p">
						{`${props.label} `}
					</Typography>
				</Grid>
			)}
			<div style={{width: "5px"}}></div>
			<Grid item>
				<Typography style={{fontSize: "12px !important"}}>{props.data}</Typography>
			</Grid>
		</Grid>
	)
}

export default FieldDisplay
